import gql from "graphql-tag";
import { GraphQlMutationBuilder } from "../../graphQL-mutation.builder";

export interface EditTipoDatoTableData {
  uuidTable: string;
  recordId: string;
  editInput: any[];
}

export class EditTipoDatoTableDataBuilder {
  private UUID_TABLE: string;
  private EDIT_INPUT: string;
  private EDIT_RECORD_ID: string;

  private get _mutation() {
    return gql`
      mutation ($uuidTable: String, $recordId: String, $editInput: [TipoDatoTableDataInputField]) {
        updateTipoDatoTableData(td: $uuidTable, _id: $recordId,input: $editInput) {
          _id
        }
      }
    `;
  }

  public withUuidTable(uuidTable: string): this {
    this.UUID_TABLE = uuidTable;
    return this;
  }

  public withInput(editInput: string): this {
    this.EDIT_INPUT = editInput;
    return this;
  }

  public withRecordId(recordId: string): this {
    this.EDIT_RECORD_ID = recordId;
    return this;
  }

  public build() {
    let mutationParams: EditTipoDatoTableData;
    const graphQlMutationBuilder: GraphQlMutationBuilder =
      new GraphQlMutationBuilder();

    mutationParams = {
      uuidTable: this.UUID_TABLE,
      recordId: this.EDIT_RECORD_ID,
      editInput: JSON.parse(this.EDIT_INPUT),
    };

    return graphQlMutationBuilder
      .withMutation(this._mutation)
      .withParams(mutationParams)
      .build();
  }
}
